const coursesAPI = require('./coursesAPI');

/**
 * STUDIEMEISTER ERROR CODES
 */
module.exports = {
  ...coursesAPI,
};
